import React from 'react';
import {useIntl} from 'react-intl';

interface PlaybackSpeedButtonProps {
    rate: number;
    onClick: () => void;
    shape: 'round' | 'rounded-square' | 'tint';
    className?: string;
}

const SHAPE_CLASSES = {
    'round': 'rounded-full bg-brand text-white hover:opacity-90',
    'rounded-square': 'rounded-xl bg-indigo-600 text-white hover:opacity-90',
    'tint': 'rounded-full bg-brand-tint text-brand-ink hover:bg-brand-tint-subtle',
};

const PlaybackSpeedButton: React.FC<PlaybackSpeedButtonProps> = ({rate, onClick, shape, className}) => {
    const intl = useIntl();
    const label = `${rate}x`;
    return (
        <button
            type="button"
            data-testid="audio-player.speed"
            aria-label={intl.formatMessage({id: 'audioPlayer.playbackSpeed', defaultMessage: 'Playback speed {rate}x'}, {rate})}
            onClick={onClick}
            className={`${SHAPE_CLASSES[shape]} min-h-8 min-w-8 flex justify-center items-center text-xs font-medium tabular-nums cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-brand-focus ${className ?? ''}`}
        >
            {label}
        </button>
    );
};

export default PlaybackSpeedButton;
